module.exports = __webpack_public_path__ + "img/4_156.171cd1b0.png";